import * as React from 'react';

const TrackingContext = /*#__PURE__*/React.createContext({});
function TrackingProvider({
  children,
  value
}) {
  return /*#__PURE__*/React.createElement(TrackingContext.Provider, {
    value: value
  }, children);
}
function useTrackingData() {
  const context = React.useContext(TrackingContext);
  if (context === undefined) {
    throw new Error('useTrackingData must be used within a TrackingProvider');
  }
  return context;
}

export { TrackingContext, TrackingProvider, useTrackingData };
